import { cn, Switch, Text } from '@risksmart-app/atomic-ui';
import { Controller, useFormContext } from 'react-hook-form';

import {
  type FieldEditorValues,
  isOptionFieldType,
  supportsDefaultValue,
} from '../config';
import { FormSelectField, FormTextField } from './FormFields';
import { OptionsEditor } from './OptionsEditor';

export const FieldEditorConfigFields = ({
  disableFieldType,
  disableFieldName,
  fieldTypeOptions,
}: {
  disableFieldType?: boolean;
  disableFieldName?: boolean;
  fieldTypeOptions: { value: string; label: string }[];
}) => {
  const { watch, control } = useFormContext<FieldEditorValues>();
  const fieldType = watch('fieldType');
  const showOptions = isOptionFieldType(fieldType);
  const defaultValueEnabled = watch('defaultValueEnabled');

  return (
    <div className={cn('flex flex-col gap-4')}>
      <FormSelectField
        name={'fieldType'}
        label={'Field type'}
        placeholder={'Select a field type'}
        options={fieldTypeOptions}
        disabled={disableFieldType}
      />
      <FormTextField
        name={'fieldName'}
        label={'Field name'}
        placeholder={'Enter field name'}
        disabled={disableFieldName}
      />
      {showOptions && !disableFieldType ? <OptionsEditor /> : null}
      {supportsDefaultValue(fieldType) ? (
        <div className={cn('flex flex-col gap-3')}>
          <Controller
            control={control}
            name={'defaultValueEnabled'}
            render={({ field }) => (
              <label className={cn('flex items-center gap-2 cursor-pointer')}>
                <Text preset={'body-sm'} render={<span />}>
                  {'Set default value'}
                </Text>
                <Switch
                  checked={field.value}
                  onCheckedChange={field.onChange}
                  size={'sm'}
                />
              </label>
            )}
          />
          {defaultValueEnabled ? (
            <FormTextField
              name={'defaultValue'}
              label={'Default value'}
              placeholder={'Enter a default value'}
            />
          ) : null}
        </div>
      ) : null}
    </div>
  );
};
